import { NextResponse } from 'next/server';
import type { ApiErrorResponse } from '../interfaces/ApiErrorResponse';

/**
 * @group Functions
 * @summary <blockquote>Handles not found errors and returns a standardized error response.</blockquote>
 * @param resource - Name of the resource that was not found
 * @returns A NextResponse with standardized error structure
 * @example
 * ```typescript
 * if (!user) {
 *   return handleNotFoundError('user');
 * }
 * ```
 */
export function handleNotFoundError(resource: string): NextResponse<ApiErrorResponse> {
  return NextResponse.json({
    error: 'Not found',
    details: `The requested ${resource} could not be found.`
  }, { status: 404 });
} 